import React from "react";
import "./HeroWorkQueue.css";

export default function HeroWorkQueue({ className = "", src = "/images/My Work Queue 1.svg" }) {
  return (
    <div className={`hero-work-queue ${className}`.trim()}>
      <div className="hero-work-queue__chrome" aria-hidden="true">
        <span className="hero-work-queue__dot" />
        <span className="hero-work-queue__dot" />
        <span className="hero-work-queue__dot" />
      </div>
      <img src={src} alt="My Work Queue" className="hero-work-queue__image" />
    </div>
  );
}
